<template>
  <div class="mobile">
    <header>
      <div @click="movePath('/ModemSearch')">
        <img src="../assets/common/kepcologo.svg"/>
<!--        <img src="../assets/mobile/m_ic_ams_logo.svg"/>-->
<!--        <img src="../assets/mobile/m_ams_logo.svg"/>-->
      </div>
      <div @click="logout">로그아웃</div>
    </header>
    <router-view/>
  </div>
</template>

<script>
import common from '../script/common'

export default {
  name: 'Mobile',
  mounted () {
    common.setCommonCode()
  },
  methods: {
    movePath (path) {
      this.$router.push(path)
    },
    logout () {
      sessionStorage.clear()
      this.$router.replace('/Login')
    }
  }
}
</script>

<style scoped>
.mobile header {
  display: flex;
  height: 60px;
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  background: #FFF;
  box-shadow: 0px -1px 0px 0px #D6DDEB inset;
  box-sizing: border-box;
}

.mobile header > div:nth-child(1) {
  display: flex;
  gap: 8px;
}

.mobile header > div:nth-child(1) > img:nth-child(1) {
  width: 154px;
}

.mobile header > div:nth-child(1) > img:nth-child(2) {

}

.mobile header > div:nth-child(2) {
  font-size: 16px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile.vue